type IntoSet<T> = Iterable<T>;

function intoSet<T>(it: IntoSet<T>): Set<T> {
	if (it instanceof Set) return it;
	return new Set(it);
}

export function intersection<T>(a: Iterable<T>, b: IntoSet<T>): Set<T> {
	const result = new Set<T>();
	const bSet = intoSet(b);
	for (const k of a) {
		if (bSet.has(k)) result.add(k);
	}
	return result;
}

export function union<T>(a: Iterable<T>, b: Iterable<T>): Set<T> {
	const result = new Set<T>();
	for (const item of a) {
		result.add(item);
	}
	for (const item of b) {
		result.add(item);
	}
	return result;
}

export function difference<T>(a: Iterable<T>, b: IntoSet<T>): Set<T> {
	const result = new Set<T>();
	const bSet = intoSet(b);

	for (const item of a) {
		if (!bSet.has(item)) result.add(item);
	}

	return result;
}

export function symmetricDifference<T>(a: IntoSet<T>, b: IntoSet<T>): Set<T> {
	const aSet = intoSet(a),
		bSet = intoSet(b);
	return union(difference(aSet, bSet), difference(bSet, aSet));
}

export function isSubset<T>(a: IntoSet<T>, b: IntoSet<T>): boolean {
	const aSet = intoSet(a),
		bSet = intoSet(b);
	if (aSet.size > bSet.size) return false;
	for (const k of aSet) {
		if (!bSet.has(k)) return false;
	}
	return true;
}

export function equal<T>(a: IntoSet<T>, b: IntoSet<T>): boolean {
	const aSet = intoSet(a),
		bSet = intoSet(b);
	if (aSet.size !== bSet.size) return false;
	return isSubset(aSet, bSet) && isSubset(bSet, aSet);
}
